import PaymentMethodPicker from "components/base/PaymentMethodPicker/PaymentMethodPicker";

export default PaymentMethodPicker;
